import React from "react";
import { useNavigate } from "react-router-dom";
import { FaWallet, FaChalkboardTeacher, FaCubes } from "react-icons/fa";
import "./Finance.css";
import PageTitle from "../../components/PageTitle";

const Finance = () => {
  const navigate = useNavigate();

  const financeOptions = [
    {
      title: "My Wallet",
      description: "Store money for future use",
      icon: <FaWallet className="finance-icon" />,
      path: "/app/wallet-transaction",
      color: "purple",
    },
    {
      title: "Tuition",
      description: "Pay my tuition fees",
      icon: <FaChalkboardTeacher className="finance-icon" />,
      path: "/app/payment",
      color: "blue",
    },
    {
      title: "Other Payments",
      description: "Pay for additional services",
      icon: <FaCubes className="finance-icon" />,
      path: "/app/others",
      color: "green",
    },
  ];

  return (
    <div className="finance-container">
      <PageTitle title="Financial Services" sub="Manage your payments and wallet" icon={<FaWallet />} />

      <div className="finance-grid">
        {financeOptions.map((option, index) => (
          <div key={index} className={`finance-card ${option.color} ${option.fullWidth ? "full-width" : ""}`} onClick={() => navigate(option.path)}>
            <div className="card-icon-container">{option.icon}</div>
            <div className="card-content">
              <h3>{option.title}</h3>
              <p>{option.description}</p>
            </div>
            <div className="card-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Finance;
